import "./Loader.css"

const Loader = () => {
  return <div className="flex center">
    <div className="loader mx-auto"></div>
  </div>;
}
 
export default Loader;